<template>
    <svg
    class="svgDownload"
        @click="clicked"
            @mouseout="mouseover"
            @mouseleave="mouseleave"
            @mouseenter="mouseenter"
            @mousedown="mousedown"
            width="18" height="20" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
       <path d="M0.5 8.21014C0.5 8.21014 4.94906 13.1005 5 13.1565V0.706543" stroke="black" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
<path d="M9.5 8.48779L5 13.1565" stroke="black" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
<path d="M0.5 15.4905H9.5" stroke="black" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>

    </svg>
</template>
<script>
export default {
    props:["color"],
    methods: {
        clicked() {
            this.$emit('clicked')
        },
        mouseover() {
            this.$emit('mouseover')
        },
        mouseleave() {
            this.$emit('mouseleave')
        },
        mousedown() {
            this.$emit('mousedown')
        },
        mouseenter() {
            this.$emit('mouseenter')
        },
    }
}
</script>
<style>

.svgDownload:hover path {
    stroke:#EF2035;
    stroke-width:2;
}

</style>